import { Fragment, useEffect, useState, useRef, useMemo } from "react";
import Header from "../../Components/Header/Header";
import Menu from "../../Components/Menu/Menu";
import Stepper from "../../Components/Stepper/Stepper";
import SeleccionVehiculo from "../../Components/SeleccionVehiculo/SeleccionVehiculo";
import Nolose from "../../Components/Nolose/Nolose";
import ValorVehiculo from "../../Components/ValorVehiculo/ValorVehiculo";
import BotonPrincipal from "../../Components/BotonPrincipal/BotonPrincipal";
import firebase from "firebase/app";
import Swal from "sweetalert2";
import { db } from "../../Firebase/firebase";
import { useAuth } from "../../AuthContext";
import { mobileVendor, mobileModel } from "react-device-detect";
import useRedirect from "../../hooks/useRedirect";
import Captcha from "../../Components/Captcha/Captcha";
import { useAgentAuth } from "../../AuthAgentContext";
import "./Cotizar.css";
import logError from "../../services/logError";
import getWhatsAppUrl from "../../utils/getWhatsAppUrl";
import AGENTES from "../../utils/agentes";
import persistUserData from "../../utils/persistUserData";
import DevicesSelect from "../../Components/DevicesSelect/DevicesSelect";
import isADevice, { getType } from "../../utils/isADevice";
import { getWoowEmployee } from "../../services/woow";
import validationVehicle from "./validationVehicle";
import getAllProspectVehicles from "../../services/prospects/getProspectVehicles";
import getVisibleProducts from "./getVisibleProducts";
import getUrlParamsAndStorageInfo from "./getUrlParamsAndStorageInfo";
import { getPartnerUser } from "../../services/partners";
import httpGetAsync from "./httpGetAsync";

const Cotizar = (props) => {
  const { history } = props;
  const redirect = useRedirect();
  const { currentUser, logout } = useAuth();
  const { currentAgentUser, isAgentLogged } = useAgentAuth();
  const vehicleBrandSelectRef = useRef();
  const vehicleModelSelectRef = useRef();
  const featuresSelectRef = useRef();
  const vehicleYearSelectRef = useRef();
  const scrollContainer = useRef();
  let queryString = window.location.search;
  let urlParams = new URLSearchParams(queryString);
  const {
    source,
    medium,
    campaign,
    deeplink,
    content,
    token,
    partnerConfig,
    partnerToken,
    qs,
    puid,
    vuid,
    disableDeepLinkParam,
    vehicleTypeParam,
    productsAvailable,
    isWowUser,
    docRef,
    currentVehicle,
    userParams,
    vehicleParams,
  } = getUrlParamsAndStorageInfo(urlParams);

  const userParamsMemo = useMemo(
    () => ({
      param_name: userParams.param_name,
      param_email: userParams.param_email,
      param_phone: userParams.param_phone,
      param_uid: userParams.param_uid,
    }),
    [
      userParams.param_name,
      userParams.param_email,
      userParams.param_phone,
      userParams.param_uid,
    ],
  );

  const vehicleParamsMemo = useMemo(
    () => ({
      param_premium: vehicleParams.param_premium,
      param_period: vehicleParams.param_period,
    }),
    [vehicleParams.param_premium, vehicleParams.param_period],
  );

  const isAgentQuote = source === "agentes";

  const visibleProducts = getVisibleProducts(
    productsAvailable,
    history,
    urlParams,
  );
  const defaultType =
    vehicleTypeParam === "devices" && isWowUser
      ? "auto"
      : vehicleTypeParam || "auto";

  // WOW agent detection - ignore previous vehicle data for WOW agents
  // This ensures WOW agents always start with a clean slate and don't get
  // previous vehicle information pre-loaded into the form
  const shouldIgnorePrevVehicleData =
    campaign === AGENTES.WOW || isWowUser || !!partnerConfig;

  const [howFindOutClupp, setHowFindOutClupp] = useState([]);
  const [otherMatchVehicle, setOtherMatchVehicle] = useState(false);
  const [userData, setUserData] = useState({ timestampFirst: Date.now() });
  const [prevVehicleData, setPrevVehicleData] = useState();
  const [loading, setLoading] = useState(false);
  const [isOpenCaptchaDialog, setIsOpenCaptchaDialog] = useState(false);
  const [allQuotedVehicles, setAllQuotedVehicles] = useState([]);
  const [woowUser, setWoowUser] = useState({});
  const [partnerUser, setPartnerUser] = useState({});
  const [prospectId, setProspectId] = useState(() => {
    if (puid) return puid;
    return currentUser?.uid || "";
  });
  const [tipoSelected, setTipoSelected] = useState(defaultType);
  const [isLoadingPrevVehicleData, setIsLoadingPrevVehicleData] =
    useState(false);
  const [params, setParams] = useState();
  const [paramsAgents, setParamsAgents] = useState();
  const [quoteData, setQuoteData] = useState({
    mobilityMeans: ["auto"],
    timestamp: Date.now(),
    timestampServer: firebase.firestore.FieldValue.serverTimestamp(),
    userAgent: navigator.userAgent,
    qStatus: Number(1),
    smartphoneCovered:
      currentAgentUser || isWowUser || partnerConfig ? false : true,
    smartphoneAmount:
      currentAgentUser || isWowUser || partnerConfig ? 0 : Number(5000),
  });
  const INITAL_PRODUCT_STATE = {
    brand: "",
    model: "",
    year: 0,
    valueCatalog: 0,
    valueUser: 0,
    features: [],
    platforms: [],
    userAgent: navigator.userAgent,
    type: getType(defaultType),
    isInsured: true,
    smartphoneCovered:
      currentAgentUser || isWowUser || partnerConfig ? false : true,
    smartphoneAmount:
      currentAgentUser || isWowUser || partnerConfig ? 0 : Number(5000),
  };

  const [vehicleData, setVehicleData] = useState(INITAL_PRODUCT_STATE);

  const [device, setDevice] = useState({
    type: tipoSelected === "devices" ? "smartphone" : tipoSelected,
    brand: "",
    model: "",
    valueUser: null,
  });

  useEffect(() => {
    const setWoowEmployee = async () => {
      try {
        const json = await getWoowEmployee(token);

        if (!json) {
          throw new Error("Error: Datos del usuario no disponibles");
        }

        setWoowUser(json);

        if (json.seleccionado) {
          handleChange(json.seleccionado);
        }
      } catch (error) {
        console.error("Error al establecer el usuario Woow:", error);
      }
    };

    if (isWowUser && token) {
      setWoowEmployee();
    }
  }, [isWowUser, token]);

  const generatedSessionId = useRef(null);

  useEffect(() => {
    if (puid) {
      if (prospectId !== puid) setProspectId(puid);
      return;
    }

    // Wait for agent auth status to be known (unless it's a Wow user which is known from URL)
    if (isAgentLogged === null && !isWowUser && !partnerConfig) return;

    if (isAgentLogged || isWowUser || partnerConfig) {
      if (!generatedSessionId.current) {
        generatedSessionId.current = db.collection("prospectsNew").doc().id;
      }
      if (prospectId !== generatedSessionId.current) {
        setProspectId(generatedSessionId.current);
      }
    } else {
      if (currentUser?.uid && prospectId !== currentUser.uid)
        setProspectId(currentUser.uid);
    }
  }, [currentUser, isWowUser, isAgentLogged, puid, prospectId, partnerConfig]);
  useEffect(() => {
    // Don't update URL if we're loading previous vehicle data
    if (isLoadingPrevVehicleData) return;

    let params = new URLSearchParams(window.location.search);
    const visibleOrder = [
      "auto",
      "moto",
      "bike",
      "eBike",
      "scooter",
      "devices",
      "smartphone",
      "laptop",
      "tablet",
    ];

    const newSelectedType =
      visibleOrder.find((type) => visibleProducts.includes(type)) || "auto";
    if (!visibleProducts.includes(tipoSelected)) {
      setTipoSelected(newSelectedType);
      setVehicleData({ ...vehicleData, type: newSelectedType });
      params.set("vType", getType(newSelectedType));
    } else {
      params.set("vType", getType(tipoSelected));
    }

    history.replace({ search: params.toString() });

    if (!isAgentLogged && !isAgentQuote) {
      window.dataLayer.push({
        event: "selección_de_seguro",
        type: tipoSelected === "otro" ? "other" : tipoSelected,
        uid: currentUser?.uid,
      });
    }
  }, [
    tipoSelected,
    history,
    isLoadingPrevVehicleData,
    shouldIgnorePrevVehicleData,
  ]);

  useEffect(() => {
    const setWoowEmployee = async () => {
      try {
        const json = await getWoowEmployee(token);

        if (!json) {
          throw new Error("Error: Datos del usuario no disponibles");
        }

        let phoneRaw = json.telefono || "";
        let phoneClean = phoneRaw.replace(/\D/g, "");

        persistUserData({
          email: json.correo,
          firstName: json.nombre,
          lastName: json.apellido_paterno,
          lastName2: json.apellido_materno,
          phone: phoneClean,
          rfc: "",
        });
      } catch (error) {
        console.error("Error al obtener los datos del usuario:", error);
      }
    };

    if (campaign === AGENTES.WOW) {
      setWoowEmployee();
    }
  }, [campaign, token]);

  useEffect(() => {
    const fetchPartnerUser = async () => {
      try {
        const json = await getPartnerUser(partnerConfig.id, partnerToken);

        if (!json) {
          throw new Error("Error: Datos del afiliado no disponibles");
        }

        setPartnerUser(json);

        if (json.seleccionado) {
          handleChange(json.seleccionado);
        }

        let phoneRaw = json.telefono || json.phone || "";
        // Keep only numbers for phone
        let phoneClean = phoneRaw.replace(/\D/g, "");

        persistUserData({
          email: json.correo || json.email || "",
          firstName: json.nombre || json.firstName || json.first_name || "",
          lastName:
            json.apellido_paterno || json.lastName || json.last_name || "",
          lastName2:
            json.apellido_materno || json.lastName2 || json.last_name2 || json.middleName || "",
          phone: phoneClean,
          rfc: json.rfc || "",
        });

        if (json.postalCode || json.zipCode) {
          localStorage.setItem("zipCode", json.postalCode || json.zipCode);
        }
        if (json.birthDate) {
          const parts = json.birthDate.split("/");
          if (parts.length === 3) {
            localStorage.setItem("birthDay", parts[0]);
            localStorage.setItem("birthMonth", parts[1]);
            localStorage.setItem("birthYear", parts[2]);
          }
        }
        if (json.gender) {
          localStorage.setItem("gender", json.gender);
        }
      } catch (error) {
        console.error("Error al obtener los datos del afiliado:", error);
      }
    };

    if (partnerConfig && partnerToken) {
      fetchPartnerUser();
    }
  }, [partnerConfig, partnerToken]);

  useEffect(() => {
    const isCluppGPTDeepLink = deeplink === "true" && puid;
    const disableDeepLink = disableDeepLinkParam === "true";
    if (isCluppGPTDeepLink && !disableDeepLink) {
      db.collection(`prospectsNew/${puid}/vehicles`)
        .limit(1)
        .orderBy("timestamp", "desc")
        .get()
        .then(async (snapshot) => {
          if (snapshot.size >= 1) {
            const vehicleId = snapshot.docs[0].id;
            localStorage.setItem("docRef", puid);
            localStorage.setItem("currentVehicle", vehicleId);
            const prospectSnap = await db
              .doc(`prospectsNew/${prospectId}`)
              .get();
            if (prospectSnap.exists) {
              const prospect = prospectSnap.data();
              persistUserData({
                email: prospect.email,
                firstName: prospect.firstName,
                lastName: prospect.lastName + " " + prospect.lastName2,
                phone: prospect.phone,
                rfc: prospect.rfc,
              });
            }

            redirect("/elegir-plan");
          }
        });
    }
  }, [puid, disableDeepLinkParam, deeplink]);

  async function handleOpenCaptchaDialog() {
    const shouldCloseCaptchaDialog = woowUser?.campania_id === "coppel";

    // Use device data if current type is a device, otherwise use vehicle data
    const dataToValidate = isADevice(tipoSelected)
      ? { ...device, type: tipoSelected }
      : { ...vehicleData, type: tipoSelected };

    if (
      allQuotedVehicles.length < 1 ||
      isAgentLogged ||
      shouldCloseCaptchaDialog
    ) {
      await validationVehicle(
        async () => await saveQuote(),
        dataToValidate,
        vehicleModelSelectRef,
        vehicleBrandSelectRef,
        vehicleYearSelectRef,
      );
    } else {
      validationVehicle(
        () => setIsOpenCaptchaDialog((prev) => !prev),
        dataToValidate,
        vehicleModelSelectRef,
        vehicleBrandSelectRef,
        vehicleYearSelectRef,
      );
    }
  }

  useEffect(() => {
    if (!currentUser) return;
    if (!prospectId) return;
    db.collection(`prospectsNew/${prospectId}/qStatusUpdates`).add({
      qStatus: 0,
      timestamp: Date.now(),
      timestampServer: firebase.firestore.FieldValue.serverTimestamp(),
    });

    if (medium === AGENTES.OZON) {
      Swal.fire({
        imageUrl:
          "https://firebasestorage.googleapis.com/v0/b/auto-clupp.appspot.com/o/assets%2Fpartners%2Fozon%2FOzon_logo.jpg?alt=media&token=9c89716a-5853-4b03-9407-e560ad0357f0",
        imageHeight: 250,
        html: '<h2 style="margin:0">¡Te damos la bienvenida a Clupp!</h2><br/>Al ser cliente de Ozon, gozas de beneficios especiales. Solo cotiza tu moto y los beneficios Ozon se verán reflejados en automático.',
        confirmButtonText: "Entendido",
        background: "#f3f4f6",
      });

      const features = new Set([
        ...vehicleData.features,
        "Soy conductor de plataforma",
      ]);
      setVehicleData({
        ...vehicleData,
        features: [...features],
      });
    }
  }, [currentUser, prospectId]);

  useEffect(() => {
    // Skip processing previous vehicle data for WOW agents
    if (shouldIgnorePrevVehicleData) return;

    if (prevVehicleData) {
      // Set loading state to prevent interference from other effects
      setIsLoadingPrevVehicleData(true);

      const features = new Set([
        ...vehicleData.features,
        ...prevVehicleData.features,
      ]);

      if (medium === AGENTES.OZON) {
        features.add("Soy conductor de plataforma");
      }

      // Previous vehicle data takes precedence - update tipoSelected first
      setTipoSelected(prevVehicleData.type);
      if (isADevice(prevVehicleData.type)) {
        setDevice({
          type: prevVehicleData.type,
          brand: prevVehicleData.brand,
          model: prevVehicleData.model,
          valueUser: prevVehicleData.valueUser,
        });

        if (!isAgentLogged && !isAgentQuote)
          window.dataLayer.push({
            event: "selección_de_seguro",
            type: prevVehicleData.type,
            uid: currentUser?.uid,
          });

        setVehicleData({
          ...vehicleData,
          type: prevVehicleData.type,
          features: prevVehicleData.features,
        });
      } else {
        const { userModel, userBrand } = prevVehicleData;
        if (userBrand) {
          prevVehicleData.brand = "Otro";
        }
        if (!userBrand && userModel) {
          prevVehicleData.model = "Otro";
        }

        setVehicleData({
          ...vehicleData,
          ...prevVehicleData,
          features: [...features],
        });
      }

      // Update URL parameters to reflect the previous vehicle type (takes precedence)
      let params = new URLSearchParams(window.location.search);
      params.set("vType", getType(prevVehicleData.type));
      history.replace({ search: params.toString() });

      // Remove the logic that gave priority to vehicleTypeParam
      // Previous vehicle data now takes precedence over URL parameter

      // Clear loading state
      setIsLoadingPrevVehicleData(false);
    } else {
      if (medium === AGENTES.OZON) {
        const features = new Set([
          ...vehicleData.features,
          "Soy conductor de plataforma",
        ]);

        setVehicleData({
          ...vehicleData,
          features: [...features],
        });
      }
    }
  }, [prevVehicleData, shouldIgnorePrevVehicleData]);

  useEffect(() => {
    // Skip loading previous vehicle data for WOW agents
    if (shouldIgnorePrevVehicleData) return;

    if (docRef && currentVehicle) {
      db.collection("prospectsNew")
        .doc(docRef)
        .get()
        .then((doc) => {
          if (doc.exists) {
            const userData = doc.data();
            setUserData(userData);
            if (userData?.howFindOut) {
              setHowFindOutClupp(userData.howFindOut);
            }
          } else console.log("No such document!");
        })
        .catch((error) => console.log("Error getting document:", error));
      db.collection("prospectsNew")
        .doc(docRef)
        .collection("vehicles")
        .doc(currentVehicle)
        .get()
        .then((doc) => {
          if (doc.exists) {
            setPrevVehicleData(doc.data());
          } else console.log("No such document!");
        })
        .catch((error) => console.log("Error getting document:", error));

      getAllProspectVehicles(docRef)
        .then((items) => setAllQuotedVehicles(items))
        .catch((error) => console.log("Error getting document:", error));
    }
  }, [currentVehicle, docRef, shouldIgnorePrevVehicleData]);

  useEffect(() => {
    setParamsAgents({
      utm_source: source,
      utm_campaign: campaign,
      name: userParamsMemo.param_name,
      email: userParamsMemo.param_email,
      phone: userParamsMemo.param_phone,
      premium: vehicleParamsMemo.param_premium,
      period: vehicleParamsMemo.param_period,
      uid: userParamsMemo.param_uid,
    });
  }, [
    source,
    campaign,
    userParamsMemo.param_name,
    userParamsMemo.param_email,
    userParamsMemo.param_phone,
    vehicleParamsMemo.param_premium,
    vehicleParamsMemo.param_period,
    userParamsMemo.param_uid,
  ]);

  useEffect(() => {
    const campaignParams = {
      utm_source: source,
      utm_campaign: campaign,
      utm_content: content,
    };

    setParams({
      ...campaignParams,
      ...vehicleParamsMemo,
      ...userParamsMemo,
    });
  }, [campaign, content, source, vehicleParamsMemo, userParamsMemo]);

  useEffect(() => {
    if (params && currentUser) {
      if (params.utm_source === "rastreator") {
        let url = `https://us-central1-auto-clupp.cloudfunctions.net/app/notify-clupp-from-rastreator?`;
        url += "&uid=" + currentUser.uid;
        url += "&type=" + params.type;
        url += "&brand=" + params.brand;
        url += "&year=" + params.year;
        url += "&model=" + params.model;
        url += "&version=" + params.version;
        url += "&vStatus=" + params.vStatus;
        url += "&gender=" + params.gender;
        url += "&birthDay=" + params.birthDay;
        url += "&birthMonth=" + params.birthMonth;
        url += "&birthYear=" + params.birthYear;
        url += "&civilStatus=" + params.civilStatus;
        url += "&zipCode=" + params.zipCode;
        url += "&isInsured=" + params.isInsured;
        url += "&iDay=" + params.iDay;
        url += "&iMonth=" + params.iMonth;
        url += "&iYear=" + params.iYear;
        url += "&iType=" + params.iType;
        url += "&name=" + params.name;
        url += "&email=" + params.email;
        url += "&phone=" + params.phone;
        url += "&premium=" + params.premium;
        url += "&rank=" + params.rank;
        url += "&cluppId=" + params.cluppId;
        url += "&campaign=" + params.utm_campaign;
        httpGetAsync(url, showURLResponse, setLoading);
        localStorage.setItem("rastreator_params", JSON.stringify(params));
        localStorage.setItem("rastreatorUserUid", currentUser.uid);
      } else {
        userParams.param_email &&
          localStorage.setItem("email", userParams.param_email);
        userParams.param_firstName &&
          localStorage.setItem("firstName", userParams.param_firstName);
        userParams.param_rfc &&
          localStorage.setItem("rfc", userParams.param_rfc);
        userParams.param_phone &&
          localStorage.setItem("phone", userParams.param_phone);
        if (userParams.param_lastName) {
          let lastnameSetted = userParams.param_lastName.split(" ");
          if (lastnameSetted.length === 2) {
            localStorage.setItem("lastName", lastnameSetted[0]);
            localStorage.setItem("lastName2", lastnameSetted[1]);
          } else {
            localStorage.setItem("lastName", userParams.param_lastName);
          }
        }
      }
    }
  }, [params, currentUser]);

  useEffect(() => {
    if (paramsAgents && currentUser) {
      if (
        params.utm_source === "BikeOn" &&
        params.utm_campaign === "deeplinkBikeOn"
      ) {
        console.log("Viene de BikeOn");
        localStorage.setItem("agents_params", JSON.stringify(paramsAgents));
        redirect("/contrata");
      }
    }
  }, [paramsAgents, currentUser]);

  function showURLResponse(response) {
    setLoading(false);
    if (!response) {
      alert("Parece que ocurrió un error. Intenta más tarde.");
      return;
    }
    if (params.utm_source === "rastreator") {
      history.push("/contrata");
    } else {
      localStorage.setItem("amountsData", response);
      redirect("/elegir-plan");
    }
  }

  const saveQuote = async () => {
    var pVNew = userData?.smartphoneAmount ? userData.smartphoneAmount : 5000;
    const x = parseInt(vehicleData.valueUser * 0.03);
    if (!userData?.smartphoneAmount) {
      if (x > 5000) {
        if (x < 30000) {
          pVNew = x;
        } else {
          pVNew = 30000;
        }
      }
    }

    try {
      setLoading(true);
      // We have to update the last vehicle quoted in case it exists
      // We need to make sure the vehicle that it's in LocalStorage actually exists
      if (currentVehicle) {
        const prevVehicleRef = db.doc(
          `prospectsNew/${prospectId}/vehicles/${currentVehicle}`,
        );

        const prevVehicle = await prevVehicleRef.get();

        if (prevVehicle.exists) {
          // update the last vehicle quoted
          await prevVehicleRef.update({
            isInsured: false,
            extras: [],
          });
        }
      }

      const quoteDataCheck = isADevice(vehicleData.type)
        ? { ...quoteData, smartphoneCovered: false, smartphoneAmount: 0 }
        : quoteData;

      const updateData = {
        ...userData,
        ...quoteDataCheck,
        ...(content === "link" &&
          !currentAgentUser && {
            agentUID: medium,
          }),
        ...((userParams.param_email || localStorage.getItem("email")) && {
          email: userParams.param_email || localStorage.getItem("email"),
        }),
        ...((userParams.param_phone || localStorage.getItem("phone")) && {
          phone: userParams.param_phone || localStorage.getItem("phone"),
        }),
        ...((userParams.param_firstName || localStorage.getItem("firstName")) && {
          firstName: userParams.param_firstName || localStorage.getItem("firstName"),
        }),
        ...((userParams.param_lastName || localStorage.getItem("lastName")) && {
          lastName: userParams.param_lastName || localStorage.getItem("lastName"),
        }),
        ...(localStorage.getItem("lastName2") && {
          lastName2: localStorage.getItem("lastName2"),
        }),
        ...(localStorage.getItem("rfc") && {
          rfc: localStorage.getItem("rfc"),
        }),
        ...(localStorage.getItem("zipCode") && {
          zipCode: localStorage.getItem("zipCode"),
        }),
        ...(localStorage.getItem("birthDay") && {
          birthDay: localStorage.getItem("birthDay"),
          birthMonth: localStorage.getItem("birthMonth"),
          birthYear: localStorage.getItem("birthYear"),
        }),
        ...(localStorage.getItem("gender") && {
          gender: localStorage.getItem("gender"),
        }),
        ...(partnerConfig && partnerUser && {
          partnerData: partnerUser,
        }),
        howFindOut: howFindOutClupp,
        discount: { name: "", percentage: 1 },
        haveADiscountCoupon: false,
        period: "year",
        quotationSoftwareVersion: qs || "2.8",
        timestamp: Date.now(),
        timestampServer: firebase.firestore.FieldValue.serverTimestamp(),
        timestampFirst: userData.timestampFirst || Date.now(),
        spDetected: `${mobileVendor || ""} ${mobileModel || ""}`,
        smartphoneAmount: isWowUser
          ? 0
          : currentAgentUser
            ? userData?.smartphoneAmount
              ? userData?.smartphoneAmount
              : Number(pVNew)
            : Number(pVNew),
        status: "Pendiente",
      };

      const prospectRef = db.doc(`prospectsNew/${prospectId}`);
      const doc = await prospectRef.get();

      if ((content === "link" && !currentAgentUser) || !doc.exists) {
        updateData["utm_campaign"] = currentAgentUser
          ? currentAgentUser?.uid
          : campaign || "";
        updateData["utm_content"] = content || "";
        updateData["utm_medium"] = currentAgentUser
          ? currentAgentUser?.uid
          : medium || "";
        updateData["utm_source"] = currentAgentUser ? "agentes" : source || "";
      }
      await prospectRef.set(updateData, { merge: true });
      let updateDataVehicle = {};

      const { userBrand, userModel, ...settedProduct } =
        isADevice(vehicleData.type) || vehicleData.type === "devices"
          ? device
          : vehicleData;

      if (settedProduct.brand === "Otro") {
        settedProduct.brand = userBrand;
        settedProduct.model = userModel;
      }
      if (settedProduct.model === "Otro") {
        settedProduct.model = userModel;
      }
      updateDataVehicle = {
        ...vehicleData,
        ...settedProduct,
      };

      const data = {
        ...updateDataVehicle,
        ...(currentAgentUser && { agentUID: currentAgentUser.uid }),
        valueCatalog: vehicleData.valueCatalog || 0,
        utm_campaign: currentAgentUser ? currentAgentUser?.uid : campaign || "",
        utm_content: content || "",
        utm_medium: currentAgentUser ? currentAgentUser?.uid : medium || "",
        utm_source: currentAgentUser ? "agentes" : source || "",
        mobility: 2,
        timestamp: Date.now(),
        smartphoneCovered:
          currentAgentUser ||
          isWowUser ||
          partnerConfig ||
          isADevice(vehicleData.type)
            ? false
            : true,
        smartphoneAmount:
          currentAgentUser ||
          isWowUser ||
          partnerConfig ||
          isADevice(vehicleData.type)
            ? 0
            : userData?.smartphoneAmount
              ? userData?.smartphoneAmount
              : Number(pVNew),
        extras: [],
        isInsured: true,
        ...(partnerConfig && partnerUser && {
          partnerData: partnerUser,
        }),
      };

      if (isWowUser && woowUser?.campania_id) {
        data["thirdPartySellerCampaignId"] = woowUser.campania_id;
      }

      if (partnerConfig) {
        data["partnerIntegrationId"] = partnerConfig.id;
        if (partnerUser?.campania_id) {
          data["thirdPartySellerCampaignId"] = partnerUser.campania_id;
        }
      }

      const vehicleId = db
        .collection(`prospectsNew/${prospectId}/vehicles`)
        .doc().id;

      await db
        .doc(`prospectsNew/${prospectId}/vehicles/${vehicleId}`)
        .set({ ...data, id: vehicleId }, { merge: true });

      localStorage.setItem("currentVehicle", vehicleId);
      let url = `https://us-central1-auto-clupp.cloudfunctions.net/app/quote-mobility-insurance-5?uid=${prospectId}`;
      if (vehicleData.type === "auto") {
        url += `&isPickup=${Boolean(vehicleData.isPickup)}`;
      }

      // generate the quotation data
      const response = await fetch(url);
      const json = await response.json();
      localStorage.removeItem("rastreatorUserUid");
      localStorage.removeItem("rastreator_params");
      localStorage.setItem("docRef", prospectId);
      const firstName = localStorage.getItem("firstName");
      const lastName = localStorage.getItem("lastName");
      const prospectName =
        firstName && lastName ? `${firstName} ${lastName}` : "";

      if (isAgentQuote) {
        await db.collection(`/agentProspects/${campaign}/expTransactions`).add({
          amount: 5,
          deleted: false,
          timestamp: Date.now(),
          metadata: {
            costumerName: prospectName || "",
            vehicleType: vehicleData.type,
            transactionType: "quote",
            description: `${vehicleData.brand} ${vehicleData.model} ${
              vehicleData?.year || ""
            }`,
          },
        });
      }

      if (params.utm_source === "rastreator") {
        setLoading(false);
        redirect("/contrata");
      } else {
        localStorage.setItem("amountsData", JSON.stringify(json));
        if (!isAgentLogged) {
          window.dataLayer.push({
            event: "cotizar",
            type: vehicleData.type,
            brand: vehicleData.brand,
            model: vehicleData.model,
            year: vehicleData.year,
          });
        }

        setLoading(false);
        redirect("/elegir-plan");
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
      Swal.fire({
        icon: "error",
        text: `Ha ocurrido un error, solicita ayuda con uno de nuestros agentes.`,
        confirmButtonText: "Contactar a un agente",

        didClose: () => {
          window.open(
            getWhatsAppUrl(
              "Hola, tengo problemas para cotizar un segundo vehículo desde la página.",
            ),
          );
        },
      });
      try {
        function parseObject(object) {
          return Object.keys(object)
            .map((key) => {
              return [key, object[key]];
            })
            .reduce((prev, current) => {
              const [key, value] = current;
              prev[key] = value ?? String(value);
              return prev;
            }, {});
        }

        await logError({
          error: String(error),
          metadata: {
            description: "Error al continuar cotizacion desde Cotizar",
            uid: currentUser.uid,
            quoteData: parseObject(quoteData),
            vehicleData: parseObject(vehicleData),
          },
        });
      } catch (error) {
        console.error(error);
        await logError({
          error: "Error al enviar error: " + String(error),
        });
      }
    }
  };

  useEffect(() => {
    // Skip scrolling for WOW agents since they don't load previous vehicle data
    if (shouldIgnorePrevVehicleData) return;

    if (prevVehicleData) {
      document.getElementById("tipoVehiculo")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [prevVehicleData, shouldIgnorePrevVehicleData]);

  const handleChange = (selectedType) => {
    setQuoteData({ ...quoteData, mobilityMeans: [selectedType] });
    setVehicleData({ ...INITAL_PRODUCT_STATE, type: selectedType });
    setTipoSelected(selectedType);
    let params = new URLSearchParams(window.location.search);
    params.set("vType", getType(selectedType));
    document.getElementById("tipoVehiculo")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <Fragment>
      {!currentAgentUser && (
        <Captcha
          onClose={() => setIsOpenCaptchaDialog(false)}
          isOpen={isOpenCaptchaDialog}
          callBack={saveQuote}
          loading={loading}
        />
      )}
      {currentUser && (
        <Fragment>
          {!isWowUser && (
            <>
              <Menu viewOption="cotizar" />
              <Header />
            </>
          )}

          <div
            className="cotizar adjusted-height"
            style={{
              paddingTop: isWowUser ? "10px" : "",
            }}
          >
            <Stepper type={tipoSelected} />
            <SeleccionVehiculo
              tipoSelected={tipoSelected}
              handleChange={handleChange}
              isWowUser={isWowUser}
              visibleProducts={visibleProducts}
              scrollContainer={scrollContainer}
            />
            {isADevice(tipoSelected) ? (
              <>
                <DevicesSelect
                  utm_source={source}
                  vehicleBrandSelectRef={vehicleBrandSelectRef}
                  vehicleModelSelectRef={vehicleModelSelectRef}
                  loading={loading}
                  saveQuote={saveQuote}
                  setDevice={setDevice}
                  device={device}
                  tipoSelected={tipoSelected}
                  setTipoSelected={setTipoSelected}
                />
                <ValorVehiculo
                  setVehicleData={setVehicleData}
                  vehicleData={vehicleData}
                  prevVehicleData={prevVehicleData}
                  tipoSelected={tipoSelected}
                  setHowFindOutClupp={setHowFindOutClupp}
                  howFindOutClupp={howFindOutClupp}
                  isAgentLogged={isAgentLogged}
                  featuresSelectRef={featuresSelectRef}
                />
              </>
            ) : (
              <>
                <Nolose
                  tipoSelected={tipoSelected}
                  saveQuote={saveQuote}
                  vehicleData={vehicleData}
                  setVehicleData={setVehicleData}
                />
                <ValorVehiculo
                  setVehicleData={setVehicleData}
                  vehicleData={vehicleData}
                  prevVehicleData={prevVehicleData}
                  tipoSelected={tipoSelected}
                  setHowFindOutClupp={setHowFindOutClupp}
                  howFindOutClupp={howFindOutClupp}
                  isAgentLogged={isAgentLogged}
                  featuresSelectRef={featuresSelectRef}
                />
                <BotonPrincipal
                  tipo={"Cotizar"}
                  goTo="/elegir-plan"
                  func={handleOpenCaptchaDialog}
                  loading={loading}
                />
              </>
            )}
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default Cotizar;
